export const isAdaptiveMode = {
  computed: {
    isAdaptiveMode () {
      return !window.matchMedia(`(min-width: 1024px)`).matches
    }
  }
}
